var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 30.3334C8.09366 30.3334 1.66699 23.9067 1.66699 16C1.66699 8.09335 8.09366 1.66669 16.0003 1.66669C23.907 1.66669 30.3337 8.09335 30.3337 16C30.3337 23.9067 23.907 30.3334 16.0003 30.3334ZM16.0003 3.66669C9.20033 3.66669 3.66699 9.20002 3.66699 16C3.66699 22.8 9.20033 28.3334 16.0003 28.3334C22.8003 28.3334 28.3337 22.8 28.3337 16C28.3337 9.20002 22.8003 3.66669 16.0003 3.66669Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2271 20.7733C11.9738 20.7733 11.7205 20.68 11.5205 20.48C11.1338 20.0933 11.1338 19.4533 11.5205 19.0666L19.0671 11.52C19.4538 11.1333 20.0938 11.1333 20.4805 11.52C20.8671 11.9066 20.8671 12.5466 20.4805 12.9333L12.9338 20.48C12.7471 20.68 12.4805 20.7733 12.2271 20.7733Z",
    fill: "#232323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7738 20.7733C19.5205 20.7733 19.2671 20.68 19.0671 20.48L11.5205 12.9333C11.1338 12.5466 11.1338 11.9066 11.5205 11.52C11.9071 11.1333 12.5471 11.1333 12.9338 11.52L20.4805 19.0666C20.8671 19.4533 20.8671 20.0933 20.4805 20.48C20.2805 20.68 20.0271 20.7733 19.7738 20.7733Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.e0d65e9df4bc8a76906af977055ee8fb.svg";
export { ForwardRef as ReactComponent };